module.exports = __webpack_public_path__ + "img/item-0.e2bb13c3.webp";